import type { User } from '../../data/domains/profile';
import { completeSession, type CompleteSessionOptions } from './completeSession';
import { offerSaveBiometricLogin } from './offerSaveBiometricLogin';

export type FinalizeLoginSuccessParams = {
  user: User;
  onDismiss: () => void;
  session_options?: CompleteSessionOptions;
  login_phone?: string;
  login_password?: string;
  offer_biometric_save?: boolean;
  t: (key: string) => string;
};

/**
 * Match legacy login success order (deprecated v1 LoginSheetContent):
 * dismiss auth UI first, then apply session on the next frame so sheet animation
 * does not race navigation.
 */
export async function finalizeLoginSuccess(params: FinalizeLoginSuccessParams): Promise<void> {
  params.onDismiss();
  completeSession(params.user, { ...params.session_options, defer: 'animationFrame' });
  if (params.offer_biometric_save && params.login_phone && params.login_password) {
    void offerSaveBiometricLogin(params.t, params.login_phone, params.login_password);
  }
}
